module.exports = __webpack_public_path__ + "img/carrousel-video-10.9ab52d7d.png";